/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ResourcePoolRequestApprovalState = 'APPROVE' | 'DENY';

export const ResourcePoolRequestApprovalState = {

    APPROVE: 'APPROVE' as ResourcePoolRequestApprovalState,

    DENY: 'DENY' as ResourcePoolRequestApprovalState
};

